import catalogContexts from "@utils/constants/catalogContexts";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

export default function computeSortBy(context, sortBy) {
  switch (context) {
    case catalogContexts.swap:
      if (!sortBy || sortBy === "our_choice") return mainIndex;

      return mainIndex.replace("principal", sortBy);
    case catalogContexts.wishlist:
    case catalogContexts.userlist:
      if (!sortBy || sortBy === "newest") return mainIndex.replace("principal", "newest");

      return mainIndex;
    case catalogContexts.sales:
      if (!sortBy || sortBy === "our_choice") return mainIndex.replace("principal", "sale");

      return mainIndex.replace("principal", sortBy);
    default:
      return mainIndex;
  }
}
